import { InstallState, WindowsUserInfo } from '@playcastdotio/CoreTypes';
import {
  authState,
  displayState,
  loginProfileState,
  machineNameState,
  machineIdState,
  machineIdAttestationReplyState,
  versionState,
  driverState,
  sanitizationState,
  restartRequiredState,
} from './shared';
import { machineIdAttestationStatusState } from '../../coordinators/app/machineIdAttestationStatusStore';
import { signMachineIdPayloadReplyState } from './signMachineIdPayloadReplyStore';
import { makeStateStore } from '@playcastdotio/StateStore';
import { isElectron } from '..';
import { RemoteHostStartResponse } from '@playcastdotio/Messaging';

const stringToHex = (str: string) => {
  let hex = '';
  for (let i = 0; i < str.length; i += 1) {
    hex += str.charCodeAt(i).toString(16);
  }
  return hex;
};

const initialInstallState: InstallState = {
  installId: '',
  firstInstall: false,
};
const installState = makeStateStore<InstallState>(initialInstallState);

const initialCurrentUserInfoState: WindowsUserInfo = {
  active: false,
  loggedIn: false,
  privilege: 'GUEST',
  unique: '',
  username: '',
};
const currentUserInfoState = makeStateStore<WindowsUserInfo>(initialCurrentUserInfoState);

const initialSurfState = true;
const surfState = makeStateStore<boolean>(initialSurfState);

const initialRemoteHostState: RemoteHostStartResponse = {
  id: '',
  displayName: '',
  remoteSessionId: '',
  machineId: '',
  version: '',
  environment: '',
};
export const remoteHostState = makeStateStore<RemoteHostStartResponse>(initialRemoteHostState);

export { machineIdAttestationReplyState, machineIdAttestationStatusState, signMachineIdPayloadReplyState };

export const getElectronStores = () => {
  return {
    driverState,
    sanitizationState,
    restartRequiredState,
    installState,
    currentUserInfoState,
    machineIdState,
    machineIdAttestationReplyState,
    signMachineIdPayloadReplyState,
    machineIdAttestationStatusState,
    machineNameState,
    displayState,
    surfState,
    versionState,
    remoteHostState,
  };
};

export const destroyAllElectronStores = (destroyListeners?: boolean) => {
  Object.values(getElectronStores()).forEach((store) => store.reset(destroyListeners));
};

loginProfileState.addListener((loginProfile) => {
  if (isElectron) {
    if (loginProfile.accessToken !== '') {
      console.debug('[Store-Electron] Updating auth state accessToken with accessToken');
      authState.currentState.accessToken = loginProfile.accessToken;
    }
    if (loginProfile.hostAuthId !== '') {
      console.debug('[Store-Electron] Updating auth state hostAuthId with hostAuthId');
      authState.currentState.hostAuthId = loginProfile.hostAuthId;
    }
    authState.updateState(authState.currentState);
  }
});
